import { useState, createContext, useContext } from "react";

const BranchNameContext = createContext(null);

export const BranchNameProvider = ({ children }) => {
  const [branchName, setBranchName] = useState("");
  const setBranchNameContext = (name) => {
    setBranchName(name);
  };
  const getBranchNameContext = () => {
    return branchName;
  };
  return (
    <BranchNameContext.Provider
      value={{ getBranchNameContext, setBranchNameContext }}
    >
      {children}
    </BranchNameContext.Provider>
  );
};
export const useBranchName = () => {
  return useContext(BranchNameContext);
};
